/**
 * Calcule une taille responsive basée sur un écran de 1920px
 * @param {number} sizePx - taille en px sur un écran 1920px
 * @param {boolean} [withBorne=false] - active le mode clamp (min 10px, max +5px)
 * @returns {string} - taille responsive (vw ou clamp)
 */
export default function normalizeSize(sizePx, withBorne = false) {
    const baseWidth = 1920
    const vwValue = (sizePx / baseWidth) * 100

    if (withBorne) {
        const minPx = sizePx - 10 < 11 ? 11 : sizePx - 10
        const maxPx = sizePx + 10
        // Use CSS clamp() for real responsive behavior
        return sizePx > 0 ? `clamp(${minPx}px, ${vwValue}vw, ${maxPx}px)` : 0
    }

    return sizePx > 0 ? `${vwValue}vw` : 0
}
